import { api } from '@/infra/axios';

export const getModuleEnvironmentsVersion = async (moduleId) => {
  return api.get(`/kubernetes/sgusuite/${moduleId}/versions`);
};
